export function limparSessaoUsuario() {
  window.localStorage.clear();
}
